import { makeStyles } from "makeStyles";
import SingleValues from "../SingleValues";
import { AppRoleAssignee } from "../models";
import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { permissionsTableStyles } from "../styles";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme),
  groupNameCell: {
    width: "220px"
  }
}));

interface Props {
  assignees?: AppRoleAssignee[];
}

const PermissionsAssignees: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.borderedTable}>
        <TableBody>
          {props.assignees?.map((assignee) => (
            <TableRow key={assignee.azureObjectId}>
              <TableCell className={classes.groupNameCell}>{assignee.name}</TableCell>
              <TableCell>
                {assignee.members?.length === 0 ? (
                  "--"
                ) : assignee.members?.length === 1 ? (
                  assignee.members[0].name
                ) : (
                  <details>
                    <summary>{assignee.members!.length} Members:</summary>
                    <SingleValues values={assignee.members?.map((m) => m.name)} />
                  </details>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default PermissionsAssignees;
